export default __webpack_public_path__ + "static/coin_orange-165e356c84c81d253dcc36ca950e57e5.png";